module.exports = __webpack_public_path__ + "static/media/administracion.79c6abaf.png";